import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <span>
          {t.footer} · {year}
        </span>
      </div>
    </footer>
  );
}
